import { ReactElement } from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyle = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
})

interface IProps {
	align?: string
	children?: ReactElement[] | ReactElement | null
	className?: string
	justify?: string
	style?: Record<string, string | number>
}

function Col(props: IProps): ReactElement {
	const { className, align, justify, style, children } = props
	const classes = useStyle()

	return (
		<div
			className={`${classes.root} ${className}`}
			style={{ alignItems: align, justifyContent: justify, ...style }}
		>
			{children}
		</div>
	)
}

Col.defaultProps = {
	align: 'flex-start',
	justify: 'center',
	className: '',
}

export default Col
